import Sidebar from './Sidebar';
import Header from './Header';

const MainLayout = ({ children, title }) => {
  return (
    <div className="flex h-screen bg-purple-50/30">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} />
        <main className="flex-1 overflow-y-auto p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
